import { Group, Spacer, Stack } from '@chakra-ui/react'
import { useState } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { Button } from '@app/components/ui/button'
import { CARD_FILTER_SIGIL } from '@app/lib/globals'
import type { Props as ContainersSelectProps } from '@app/next/changelog/components/containersSelect'
import ContainersSelect from '@app/next/changelog/components/containersSelect'
import EntityForm from '@app/pages/shared/entities/components/entityForm'
import MapDrawer from '@app/pages/strategies/components/drawer/mapDrawer'

const param = `${CARD_FILTER_SIGIL}containerNodeIds`

const AddWorkItemDrawer = () => {
  const { strategyId } = useParams()
  const [searchParams] = useSearchParams()
  const defaultContainerNodeIds = searchParams.get(param)?.split(',')
  const [containerNodeIds, setContainerNodeIds] = useState<string[]>(defaultContainerNodeIds || [])
  const [step, setStep] = useState(0)
  const location = useLocation()
  const navigate = useNavigate()
  const onCancel = () => navigate(`..${location.search}`)

  const onChange: ContainersSelectProps['onChange'] = (selected) => {
    setContainerNodeIds(selected.map((s) => s.id))
  }

  return (
    <MapDrawer p={4} top="24px" right="74px" left="auto" bottom="auto">
      {step === 0 && (
        <Stack gap={4}>
          <ContainersSelect
            strategyId={strategyId}
            onChange={onChange}
            placeholder="Select containing works"
            defaultContainerNodeIds={defaultContainerNodeIds}
          />
          <Group>
            <Spacer />
            <Button onClick={() => setStep(1)}>Next</Button>
          </Group>
        </Stack>
      )}
      {step === 1 && (
        <EntityForm onCancel={onCancel} redirectOnCreate={(event) => `../${event.id}`}>
          <input type="hidden" name="containerNodeIds" value={containerNodeIds.join(',')} />
        </EntityForm>
      )}
    </MapDrawer>
  )
}

export default AddWorkItemDrawer
